import { ApplicationConfig, inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient } from '@angular/common/http';
import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { provideDatabase, getDatabase } from '@angular/fire/database';
import { environment } from '../environments/environment';
import { defineCustomPreset } from '../assets/styles/customTheme/definePreset';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { AuthService } from './core/services/auth.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(),
    provideAnimationsAsync(),
    provideFirebaseApp(() => initializeApp(environment.database)),
    provideFirestore(() => getFirestore()),
    provideDatabase(() => getDatabase()),
    providePrimeNG({
      theme: {
        preset: defineCustomPreset,
        options: {
          prefix: 'p',
          darkModeSelector: '',
          cssLayer: false
        }
      }
    }),
    provideAuth(() => getAuth()),
    provideAppInitializer(() => {
      void inject(AuthService).initAuth();
    }),
  ],
};
